<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <div class="form-group">
        
        <select class="form-control" :disabled="disabled || emptyStates" :placeholder="placeholder" :value="value" @change="updateValue($event)" :aria-label="{label}">
          <option :value="null"></option>
          <option v-for="(item) in availableStates" :key="item.Id" :value="item.Id">{{item.DisplayName}}</option>
        </select>
        <i class="fa fa-chevron-down"></i>
      </div>
   </div>
</template>

<script>
    import { mapState } from 'vuex';
export default {
  name: "StateSelect",
  props: ['label', 'placeholder', 'value', 'disabled', 'states'],
  methods:{
    updateValue(e){
      this.$emit("input", e.target.value);
      this.$emit('state-changed', e.target.value);
    }
  },
  computed: {
    ...mapState(['usStates']),
    availableStates(){
      return this.states ? this.states : this.usStates;

    },
    emptyStates(){
      return this.availableStates.length === 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-group{
    margin-bottom: 0px;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -o-appearance: none;
      /* no standardized syntax available, no ie-friendly solution available */
    }
    select + i.fa {
      float: right;
      margin-top: -26px;
      margin-right: 5px;
      /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
      pointer-events: none;
      /* everything after this is just to cover up the original arrow */
      /* (for browsers that don't support the syntax used above) */
      background: inherit;
      padding-right: 5px;
    }
  }
</style>
